import { ReactNode } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Stack } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// 一覧 Accordion の共通骨格(CarryOutAccordion/CarryInAccordion で同型だったヘッダ構造を抽出)。
// header は Stack 内に並べる要素(リンク/状態Chip群/スペーサ/登録者caption等)を呼び出し側が渡す。
export function StatusAccordion({ header, children, defaultExpanded }: {
  header: ReactNode;
  children: ReactNode;
  defaultExpanded?: boolean;
}) {
  return (
    <Accordion disableGutters variant="outlined" defaultExpanded={defaultExpanded} sx={{ backgroundColor: "background.paper" }}>
      <AccordionSummary component="div" expandIcon={<ExpandMoreIcon />}>
        <Stack direction="row" alignItems="center" gap={1.5} flex={1} mr={2} flexWrap="wrap">
          {header}
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ backgroundColor: "grey.50" }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
}
